import api from './api';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const ringcentralService = {
  getStatus: async () => {
    const response = await api.get('/ringcentral/status');
    return response.data;
  },

  getOAuthStartUrl: (returnTo) => {
    const params = new URLSearchParams();
    if (returnTo) params.set('returnTo', returnTo);
    const query = params.toString();
    return `${API_BASE}/ringcentral/oauth/start${query ? `?${query}` : ''}`;
  },

  disconnect: async () => {
    const response = await api.post('/ringcentral/disconnect');
    return response.data;
  },

  placeCall: async (practiceId, patientId, payload = {}) => {
    const response = await api.post(
      `/ringcentral/practices/${practiceId}/patients/${patientId}/calls`,
      payload
    );
    return response.data;
  },

  getCall: async (callId) => {
    const response = await api.get(`/ringcentral/calls/${callId}`);
    return response.data;
  },

  getWebPhone: async () => {
    const response = await api.get('/ringcentral/webphone');
    return response.data;
  },

  updateCall: async (callId, payload = {}) => {
    const response = await api.patch(`/ringcentral/calls/${callId}`, payload);
    return response.data;
  },
};

export default ringcentralService;
